import { UrlEventType, UrlParameter, VisitType } from 'src/requester';
import {
  DeviceDataType,
  DeviceType,
  IKameleoonData,
  KameleoonData,
} from './types';
import { TrackingStatus } from 'src/types';

/**
 * @class
 * Device - a class for creating an instance for device of a certain type
 * */
export class Device implements IKameleoonData {
  public status: TrackingStatus;

  private device: DeviceType;

  /**
   * @param {DeviceType} device - one of the available device types from `DeviceType` enum
   * */
  constructor(device: DeviceType) {
    this.device = device;
    this.status = TrackingStatus.Unsent;
  }

  get url(): string {
    // --- Note ---
    // If SDK is used in vanilla JS codebase, then you're also able to create an instance
    // with no required data, we don't want send anything to tracking in that case
    if (!this.device) {
      return '';
    }

    return UrlEventType.StaticData + UrlParameter.DeviceType + this.device;
  }

  get data(): DeviceDataType {
    return {
      device: this.device,
      type: KameleoonData.Device,
      status: this.status,
    };
  }

  /**
   * @private
   * @method _fromRaw - an internal method for creating a Device instance from raw data
   * @param {DeviceDataType} data - a raw data
   * @return {Device} a Device instance
   * */
  public static _fromRaw(data: DeviceDataType): Device {
    const { device: deviceType, status } = data;
    const device = new Device(deviceType);

    device.status = status;

    return device;
  }

  /**
   * @private
   * @method _fromVisit - an internal method for creating an instance of Device class from a visit
   * @param {VisitType} visit - a visit
   * @returns {Device | undefined} an instance of Device class or undefined if browser can not be found among visits
   * */
  public static _fromVisit(visit: VisitType): Device | undefined {
    if (visit.staticDataEvent?.data.deviceType) {
      return new Device(visit.staticDataEvent.data.deviceType);
    }

    return undefined;
  }
}
